export default __webpack_public_path__ + "static/media/Stalker's Tunic of the Hidden Tomb.60c61745.jpg";